module.exports = __webpack_public_path__ + "media/images/lb/487-894807b8429e3ca1ef8d218af48f958c.svg";